import {
  DefaultButton,
  Dropdown,
  Panel,
  PanelType,
  PrimaryButton,
} from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';
import { useUpdateInvitationGroupMappings } from './updateInvitationGroupMappingsPanel/utility/useUpdateInvitationGroupMappings';
import { mapInvitationGroupToDropdown } from './utility/mapEntities';

const UpdateInvitationGroupMappingsPanel = ({
  selectedHearingTypeKey,
  invitationGroupsByHearingTypeId,
  invitationGroups,
}) => {
  const { t: translator } = useTranslation();

  const {
    isPanelOpen,
    onPanelClose,
    selectedInvitationGroupIds,
    setSelectedInvitationGroupIds,
    onConfirm,
  } = useUpdateInvitationGroupMappings(
    selectedHearingTypeKey,
    invitationGroupsByHearingTypeId,
  );

  const onChange = (_, item) => {
    if (item) {
      setSelectedInvitationGroupIds(
        item.selected
          ? [...selectedInvitationGroupIds, item.key]
          : selectedInvitationGroupIds.filter((key) => key !== item.key),
      );
    }
  };

  return (
    <div>
      <Panel
        isOpen={isPanelOpen}
        type={PanelType.medium}
        onDismiss={onPanelClose}
        isLightDismiss={true}
        onOuterClick={() => {}}
        closeButtonAriaLabel={translator('ariaLabel.panelClose')}
      >
        <div>
          <div className="panel-content">
            <h3 className="panel-header">
              {translator(
                'pages.adminInvitationGroups.updateInvitationGroupToHearingTypePanel.header',
              )}
            </h3>
            <Dropdown
              placeholder={translator(
                'pages.adminInvitationGroups.updateInvitationGroupToHearingTypePanel.placeHolder',
              )}
              label={translator(
                'pages.adminInvitationGroups.updateInvitationGroupToHearingTypePanel.guideText',
              )}
              selectedKeys={selectedInvitationGroupIds}
              onChange={onChange}
              multiSelect
              options={invitationGroups.map(mapInvitationGroupToDropdown)}
            />
          </div>
          <div className="panel-buttons">
            <DefaultButton
              text={translator('global.cancel')}
              onClick={onPanelClose}
            />
            <PrimaryButton
              text={translator('global.confirm')}
              onClick={onConfirm}
            />
          </div>
        </div>
      </Panel>
    </div>
  );
};

export { UpdateInvitationGroupMappingsPanel };
